// assets/accordion.js
window.Accordion = (function () {
    function init() {
      document.querySelectorAll("[data-accordion]").forEach((accordion) => {
        const trigger = accordion.querySelector(".accordion__trigger");
        const content = accordion.querySelector(".accordion__content");
  
        // Garantir que comece aberto
        accordion.classList.add("open");
        content.style.display = "block";
  
        trigger.addEventListener("click", () => {
          const isOpen = accordion.classList.contains("open");
  
          if (isOpen) {
            accordion.classList.remove("open");
            content.style.display = "none";
          } else {
            accordion.classList.add("open");
            content.style.display = "block";
          }
        });
      });
    }
  
    // Executa automaticamente
    document.addEventListener("DOMContentLoaded", init);
  
    return { init };
  })();
  